// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"fce399e5","558":"0dd6f011","681":"14f33598"}[chunkId] + ".chunk.js";
};